import { KreFormFieldConfig } from "@kre-form/core";
export function requiredValidationMessage(err, field: KreFormFieldConfig) {
  return `${field.templateOptions.label}不能为空`;
}
export function minlengthValidationMessage(err, field: KreFormFieldConfig) {
  return `${field.templateOptions.label}最小长度为${field.templateOptions.minLength}`;
}
export function maxlengthValidationMessage(err, field: KreFormFieldConfig) {
  return `${field.templateOptions.label}最大长度为${field.templateOptions.maxLength}`;
}
export function minValidationMessage(err, field: KreFormFieldConfig) {
  return `${field.templateOptions.label}最小值为${field.templateOptions.min}`;
}
export function maxValidationMessage(err, field: KreFormFieldConfig) {
  return `${field.templateOptions.label}最大值为${field.templateOptions.max}`;
}

export let validationConfig = {
  validationMessages: [
    { name: "required", message: requiredValidationMessage },
    { name: "null", message: "不能为NULL" },
    { name: "minlength", message: minlengthValidationMessage },
    { name: "maxlength", message: maxlengthValidationMessage },
    { name: "min", message: minValidationMessage },
    { name: "max", message: maxValidationMessage },
    { name: "multipleOf", message: "ssss" },
    { name: "exclusiveMinimum", message: "ssss" },
    { name: "exclusiveMaximum", message: "ssss" },
    { name: "minItems", message: "ssss" },
    { name: "maxItems", message: "ssss" },
    { name: "uniqueItems", message: "should NOT have duplicate items" },
    { name: "const", message: "ssss" },
    { name: "pattern", message: "不满足正则表达式" },
  ],
  types: [
    { name: "string", extends: "input" },
    {
      name: "number",
      extends: "input",
      defaultOptions: {
        templateOptions: {
          type: "number",
        },
      },
    },
    {
      name: "integer",
      extends: "input",
      defaultOptions: {
        templateOptions: {
          type: "number",
        },
      },
    },
    { name: "boolean", extends: "checkbox" },
    { name: "enum", extends: "select" },
    { name: "array", extends: "array" },
    { name: "object", extends: "object" },
  ],
};
